export default [
    {
        path: "/publish-part-one",
        component: () => import("../Components/List.vue"),
        name: "publish-part-one",
        meta: {
            requiresAuth: true,
        },
    },
    
    {
        path: "/publish-part-one/create",
        component: () => import("../Components/Create.vue"),
        name: "publish-part-one.create",
        meta: {
            requiresAuth: true,
        },
    },
];
